<template>
  <div :id="'model-video-box-' + video.id" class="video-container">
    <iframe
      v-if="videoSrc"
      :src="videoSrc"
      :autoplay="false"
      controls
      playsinline
      class="iframe-video"
      id="iframe-video"
      ref="iframeElement"
      @load="onIframeLoad"
    ></iframe>
    <img
      v-else
      src="https://admin.belladasemana.com.br/assets/img/thumb-video.jpg"
      style="width: 100%"
      id="modal-video-src"
    />
    <i class="wtmrk">{{ user.id }}</i>
    <button class="fullscreen-button" @click="toggleFullscreen()">
      <i class="icon-resize-full"></i>
    </button>
    <div class="loader-container" v-if="isLoading">
      <div class="loader"></div>
    </div>
  </div>
  <ModalMessages @showModalMessages="showModalMessages" :options="optionsMsg" width="600px" />
</template>
<script setup lang="ts">
  import ModalMessages from '../Modais/ModalMessages.vue'
</script>

<script lang="ts">
  import { defineComponent } from 'vue'
  import { userStore } from 'stores/user'
  import { localeStore } from 'stores/locale'
  import { mapState } from 'pinia'
  import { jwtStore } from '../../stores/jwt'

  export default defineComponent({
    name: 'BoxVideoModel',
    props: ['video'],
    components: { ModalMessages },
    watch: {
      video: function () {
        this.videoSrc = !this.firefox() ? this.getVideo() : ''
        this.validaFirefox()
      },
      videoSrc: function () {
        this.validaFirefox()
      }
    },
    mounted() {
      this.videoSrc = this.getVideo()
      if (this.firefox()) {
        this.videoSrc = ''
      }

      this.checkVisibility()
      this.interval = setInterval(this.checkVisibility, 1000)
    },
    unmounted() {
      clearInterval(this.interval)
    },
    data() {
      return {
        optionsMsg: {
          showModal: false,
          titleModal: '',
          textBodyModal: '',
          textButtonModal: ''
        },
        isVisible: false,
        videoSrc: '',
        isInPictureInPictureEnabled: false
      }
    },
    methods: {
      getVideo() {
        let res = this.video.videoPath
          .replace('storage/videos', 'stream/videosHls')
          .replace('.mp4', '.xyd')

        res += this.jwt ? `&hash=${this.jwt}` : 'a'
        return res
      },
      validaFirefox() {
        if (!this.videoSrc && !this.isInPictureInPictureEnabled) {
          let msg =
            this.locale === 'pt-br'
              ? 'Momentaneamente não é possível acessar os vídeos do Bella da Semana. Por favor, acesse através de outro navegador. Agradecemos a sua compreensão!'
              : 'At the moment it is not possible to access Bella Club videos. Please, use an alternative navigator in order to access. We appreciate your understanding!'
          this.showModalMessages({
            message: {
              show: true,
              title: 'Error',
              textBody: msg,
              textButton: this.locale === 'pt-br' ? 'Fechar' : 'Close'
            }
          })
        } else if (!this.videoSrc && this.isInPictureInPictureEnabled) {
          let msg =
            this.locale === 'pt-br'
              ? 'Momentaneamente não é possível acessar as lives do Bella da Semana com o picture in picture ativado. Por favor, desative e recarregue a página. Agradecemos a sua compreensão!'
              : 'At the moment it is not possible to access Bella Club lives using picture in picture. Please, disable and reload site. We appreciate your understanding!'
          this.showModalMessages({
            message: {
              show: true,
              title: 'Error',
              textBody: msg,
              textButton: this.locale === 'pt-br' ? 'Fechar' : 'Close'
            }
          })
        }
      },
      onIframeLoad() {
        this.$refs.iframeElement.contentWindow.postMessage(
          { type: 'ENTER_PICTURE_IN_PICTURE' },
          '*'
        )
        window.addEventListener('message', this.handleMessage)
      },
      handleMessage(event) {
        if (event.data.type === 'PICTURE_IN_PICTURE_STATE_CHANGE') {
          this.isInPictureInPictureEnabled = event.data.isInPictureInPicture

          if (this.isInPictureInPictureEnabled) this.videoSrc = ''
        }
      },
      checkVisibility() {
        const icon: any = document.querySelector('.wtmrk')
        this.isVisible = icon && icon.offsetParent !== null

        let computedStyle = icon ? window.getComputedStyle(icon) : null
        let animationName = computedStyle ? computedStyle.animationName : null

        if (
          !this.isVisible ||
          animationName == 'none' ||
          computedStyle.animationDuration != '15s' ||
          computedStyle.animationIterationCount != 'infinite'
        )
          this.videoSrc = ''
        if (icon) {
          icon.style =
            'position: absolute;left: 3%;top: 3%;color: #cccccc !important;opacity: 0.2 !important;visibility: visible !important;font-size: 1rem !important'
          icon.class = 'wtmrk'
        }
      },
      showModalMessages(data) {
        this.optionsMsg.showModal = data.message.show
        this.optionsMsg.titleModal = data.message.title
        this.optionsMsg.textBodyModal = data.message.textBody
        this.optionsMsg.textButtonModal = data.message.textButton
      },
      iOS() {
        return [
          'iPad Simulator',
          'iPhone Simulator',
          'iPod Simulator',
          'iPad',
          'iPhone',
          'iPod'
        ].includes(navigator?.userAgentData?.platform || navigator?.platform)
      },
      firefox() {
        return navigator?.userAgent.includes('Firefox')
        // return false
      },
      toggleFullscreen() {
        if (!this.iOS()) {
          if (!document.fullscreenElement) {
            document.getElementById('model-video-box-' + this.video.id).requestFullscreen()
            document.getElementById('model-video-box-' + this.video.id).classList.toggle('full')
          } else if (document.exitFullscreen) {
            document.getElementById('model-video-box-' + this.video.id).classList.toggle('full')
            document.exitFullscreen()
          }
        } else {
          document
            .getElementById('model-video-box-' + this.video.id)
            .classList.toggle('video-container-ios')
        }
      }
    },
    computed: {
      ...mapState(userStore, ['user', 'isLoggedIn', 'isActiveUser']),
      ...mapState(localeStore, ['locale']),
      ...mapState(jwtStore, ['jwt'])
    }
  })
</script>

<style scoped>
  .iframe-video {
    width: 100%;
    min-height: 52vh;
  }

  .video-container {
    position: relative;
  }

  .video-container-ios {
    position: fixed; /* Fixa o contêiner na tela */
    top: 0;
    left: 0;
    width: 100vw; /* Largura total da viewport */
    height: 100vh; /* Altura total da viewport */
    background-color: black; /* Fundo preto para simular fullscreen */
    z-index: 9999; /* Coloca o contêiner acima de outros elementos */
  }

  .full {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .full iframe {
    height: 100vh;
  }

  .video-container-ios iframe {
    height: 100vh;
  }

  .fullscreen-button {
    position: absolute;
    top: 3%;
    right: 1%;
    z-index: 10;
  }

  .wtmrk {
    position: absolute;
    left: 3%;
    top: 3%;
    color: #cccccc;
    opacity: 0.2;
    visibility: visible !important;
    animation: 15s moving-watermark infinite;
  }

  @keyframes moving-watermark {
    0% {
      left: 3%;
      top: 50%;
    }

    25% {
      left: 50%;
      top: 3%;
    }

    50% {
      left: 50%;
      top: 93%;
    }

    75% {
      left: 93%;
      top: 50%;
    }

    100% {
      left: 3%;
      top: 50%;
    }
  }

  i[class*='icon-']:before {
    color: #ffffff;
    font-size: 25px;
  }

  @media screen and (max-width: 970px) {
    .video-container {
      width: 98vw;
    }
    .video-container-ios {
      width: 100vw;
    }
  }
</style>
